import { memo, useEffect, useState } from 'react';
import Table from '../../components/Table/Table';
import DateInput from '../../components/DateInput';
import Filter from '../../components/Filter/Filter';
import { FirstFilterLine, SecondFilterLine } from '../../components/Filter/Filter.styles';
import TextField from '../../components/TextField';
import Wrapper from '../../components/Wrapper/Wrapper';
import Button from '../../components/Button/Button';
import { useForm } from 'react-hook-form';
import { ImSearch } from 'react-icons/im';
import SelectOptions from '../../components/SelectOptions';
import { useDispatch, useSelector } from 'react-redux';
import { transfersFetchAction, transfersIDFetchAction, tedAproved } from '../../store/fetchActions/transfersActions';
import StatusContainerTed from '../../components/StatusContainer/StatusContainerTed';
import ModalTwoFactor from '../../components/TwoFactor/ModalTwoFactor';
import * as dayjs from 'dayjs';
import formatMoney from '../../utils/functions/formatMoneyBRL';
import InformationTransfer from './components/InformationTed';
import Modal from '../../components/Modal/Modal';
import transformObjectUppercase from '../../utils/functions/transformObjectUppercase';
import useCallFilter from '../../utils/hooks/useCallFilter';
import { getPaymentWayAndTransactionTypes } from '../../store/fetchActions/reportsActions';
import * as S from './Transferencias.styles';
import verifyEmptyValues from '../../utils/verifyEmptyValues';
import { useTheme } from 'styled-components';
import moment from 'moment';
import { arrayTipoTransacao, pagesOptions } from '../../utils/constant';
import Loading from '../../components/Loading';
import NameAndDocumentIdGrid from '../AdminPix/components/NameAndDocumentIdGrid';

import { Box, Checkbox, Tooltip } from '@mui/material';
import * as Styled from '../PerfisUsuarios/PerfisUsuarios.styles';
import IconAntifraudeAnalise from '../../assets/icon/IconAntifraudeAnalise';
import IconAntifraudeAprovada from '../../assets/icon/IconAntifraudeAprovada';
import IconAntifraudeReprovada from '../../assets/icon/IconAntifraudeReprovada';
import IconAntifraudeSemAnalise from '../../assets/icon/IconAntifraudeSemAnalise';
import IconAntifraudeFalhaAnalise from '../../assets/icon/IconAntifraudeFalhaAnalise';
import { transactionsRefetchFailedAction } from '../../store/fetchActions/transactionsActions';
import { HiOutlineEye } from 'react-icons/hi';
import useCheckBoxTedTransaction from './useCheckBoxTedTransaction';
import { NoSpecialCharacter } from '../../utils/regex';

function TransferenciaTed() {
  const theme = useTheme();
  const dispatch = useDispatch();
  const [filterData, setFilterData] = useState({
    SEARCH: '',
    DATA_INICIAL: '',
    DATA_FINAL: '',
    TIPO: 'Ted',
  });
  const [isModalInfoOpen, setIsModalInfoOpen] = useState(false);
  const [ModalInfoData, setModalInfoData] = useState({});
  const [filter, setFilter] = useState({
    SEARCH: '',
    DATA_INICIAL: '',
    DATA_FINAL: '',
    AGENCIA: '',
    CONTA: '',
    TIPO: 'Ted',
    TIPO_TRANSACAO: '',
    LIMIT: 10,
    PAGE: 1,
  });
  const [dateInicial, setDateInicial] = useState(null);
  const [dateFinal, setDateFinal] = useState(moment().format('YYYY-MM-DD'));

  const [totalSelected, setTotalSelected] = useState({
      totalTransactions: 0,
      totalValue: 0,
    });

  useEffect(() => {
    dispatch(getPaymentWayAndTransactionTypes());
  }, []);

  const { transfersData, paginationTransfers, loadingTransfers, errorTransfers, messageTransfers } = useSelector(
    (state) => state.transfers,
  );

  const { status_transacao_ted } = useSelector((state) => state?.reports);

  useCallFilter(filterData, setFilter, transfersFetchAction, 0, 0);

  const [showModalTwoFactor, setShowModalTwoFactor] = useState(false);

  const { handleSubmit, control } = useForm({});
  const { control: tokenControl } = useForm({});

  const { transactionSelected, setTransactionSelected, handleChangeSelectAll, verifyIfAllTransactionsAreSelected } =
    useCheckBoxTedTransaction(transfersData, setTotalSelected);

  const updateDataGrid = () => {
    dispatch(transfersFetchAction(transformObjectUppercase({ ...filter, TIPO: 'Ted' })));
  };

  const resetTransactionSelected = () => {
    setTransactionSelected([]);
    setTotalSelected({ totalTransactions: 0, totalValue: 0 });
    setShowModalTwoFactor(false);
  };

  const handleCloseAndResetTransactionSelected = () => {
    resetTransactionSelected();
  };

  const aproveTransactionBatch = () => {
    setShowModalTwoFactor(true);
  };

  const aproveTransaction = (token) => {
    dispatch(
      tedAproved(
        {
          TRANSACOES: transactionSelected,
          CPFCNPJ_AGENTE: NoSpecialCharacter(localStorage.getItem('cpfcnpj')),
        },
        close(),
      ),
    );
  };

  const verifyIfTransactionIsDisabled = (transfer) => {
    return transfer.STATUS_DESCRICAO !== 'AGUARDANDO';
  };


  const handleSelectTransaction = (idTransaction) => {
    setTransactionSelected((prev) =>
      prev.includes(idTransaction) ? prev.filter((id) => id !== idTransaction) : [...prev, idTransaction],
    );
  };

  const filterTable = (data) => {
    data.DATA_INICIAL = dateInicial;
    data.DATA_FINAL = dateFinal;
    data.TIPO = 'Ted';
    setFilterData(data);
  };

  useEffect(() => {
    dispatch(transfersFetchAction(transformObjectUppercase({ ...filter, TIPO: 'Ted' })));
  }, [filter.PAGE]);

  const arrayStatus = status_transacao_ted?.map((status) => {
    return { ID: status.ID, NOME: status.DESCRICAO };
  });

  arrayStatus.unshift({ ID: 0, NOME: 'TODOS' });
const [retrying, setRetrying] = useState(false);
  const retryTransaction = (transaction) => {
    const params = filterData.length > 0 ? filterData : filter
      setRetrying(true);
      dispatch(
      transactionsRefetchFailedAction({
            ID_TRANSACAO: transaction.ID,
        ...params,
      }),
    ).finally(() => setRetrying(false));
    };

  const header = [
    {
      id: 'id',
      name: '',
      align: 'center',
    },
    {
      id: 'data e hora',
      name: 'DATA/HORA',
      align: 'center',
    },
    {
      id: 'identifier',
      name: 'IDENTIFICADOR',
      align: 'left',
    },
    { id: 'banco', name: 'BANCO', align: 'left' },
    { id: 'agencia', name: 'AGENCIA', align: 'left' },
    { id: 'conta', name: 'CONTA', align: 'left' },
    { id: 'tipo', name: 'TIPO', align: 'left' },
    { id: 'valor', name: 'VALOR', align: 'right' },
    { id: 'status', name: 'STATUS', align: 'center' },
    { id: 'acoes', name: 'AÇÕES', align: 'center' },
  ];

  const renderAntifraudeIcon = (transfer) => {
    switch (transfer?.ACTION) {
      case 'REVIEW':
        return (
          <Tooltip title="Em análise">
            <Styled.IconV2Container backgroundcolor={'#FFA8061A'} cursor>
              <IconAntifraudeAnalise />
            </Styled.IconV2Container>
          </Tooltip>
        );
      case 'APPROVED':
        return (
          <Tooltip title="Aprovada">
              <Styled.IconV2Container backgroundcolor={'#00BA821A'} cursor>
                <IconAntifraudeAprovada />
              </Styled.IconV2Container>
            </Tooltip>
        )
      case 'REJECTED':
        return (
          <Tooltip title="Reprovada">
            <Styled.IconV2Container backgroundcolor={'#FF4C511A'} cursor>
              <IconAntifraudeReprovada />
            </Styled.IconV2Container>
          </Tooltip>
        );
      case 'FAILED':
        return (
          <Tooltip title="Falha na análise">
          <Styled.IconV2Container
            onClick={!retrying ? () => retryTransaction(transfer) : undefined}
              backgroundcolor={'#FF4C511A'}
              style={{ pointerEvents: retrying ? 'none' : 'auto', opacity: retrying ? 0.6 : 1 }}
          >
            <IconAntifraudeFalhaAnalise />
          </Styled.IconV2Container>
        </Tooltip>
        );
      default:
        return (
          <Tooltip title="Sem análise">
            <Styled.IconV2Container backgroundcolor={'#BCBCBC33'} cursor>
              <IconAntifraudeSemAnalise />
            </Styled.IconV2Container>
          </Tooltip>
        );
    }
  }

  const inspectUser = (ID) => {
    dispatch(
      transfersIDFetchAction(ID, (res) => {
        setModalInfoData({ ...res, ID });
        setIsModalInfoOpen(true);
      }),
    );
  };

  const body = transfersData?.map((transfer) => {
    return {
      data: [
        {
          info: (
            <Checkbox
              onChange={(event) => {
                event.stopPropagation();
                setTotalSelected((prev) => ({
                  ...prev,
                  totalTransactions: prev.totalTransactions + (event.target.checked ? 1 : -1),
                  totalValue:
                    prev.totalValue +
                    (event.target.checked ? parseFloat(transfer.VALOR) : parseFloat(transfer.VALOR) * -1),
                }));
                handleSelectTransaction(transfer.ID);
              }}
              checked={transactionSelected.includes(transfer.ID)}
              disabled={verifyIfTransactionIsDisabled(transfer)}
            />
          ),
          align: 'center',
          isCheckBox: true,
        },
        {
          info: dayjs(transfer.DATA_INSERT).format('DD/MM/YYYY HH:mm:ss') || '-----',
          align: 'center',
        },
        {
          info: <NameAndDocumentIdGrid name={transfer?.NOME} documentId={transfer?.CPFCNPJ} />,
          align: 'left',
          width: '45rem',
        },
        {
          info: verifyEmptyValues(transfer.TEDINTERNA === 'S' ? transfer.BANCO_DESTINO : transfer.BANCO),
          align: 'left',
          width: '15rem',
        },
        {
          info: verifyEmptyValues(transfer.TEDINTERNA === 'S' ? transfer.AGENCIA_DESTINO : transfer.AGENCIA),
          align: 'left',
          width: '15rem',
        },
        {
          info: verifyEmptyValues(transfer.TEDINTERNA === 'S' ? transfer.CONTA_DESTINO : transfer.CONTA),
          align: 'left',
          width: '15rem',
        },
        {
          info: transfer.TIPOTRANSFERENCIA,
          align: 'left',
          width: '15rem',
        },
        {
          info:
            transfer.TIPOTRANSFERENCIA === 'CRÉDITO' ? (
              <S.ColorValue mycolor={theme.colors.darklimeGreen} myfont={'500'}>
                {'R$ + ' + formatMoney(transfer.VALOR)}
              </S.ColorValue>
            ) : (
              <S.ColorValue mycolor={theme.colors.vividRed_2} myfont={'500'}>
                {'R$ - ' + formatMoney(transfer.VALOR)}
              </S.ColorValue>
            ),
          align: 'right',
        },
        {
          info: transfer.STATUSTRANSACAO ? (
            <StatusContainerTed
              code={String(transfer.STATUSTRANSACAO)}
              description={transfer.STATUS_DESCRICAO}
            ></StatusContainerTed>
          ) : (
            '-----'
          ),
          align: 'center',
        },
        {
          info: (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '6px' }}>
              {
                renderAntifraudeIcon(transfer)
              }
              <Tooltip title="Visualizar transferência">
                <Styled.IconV2Container
                  onClick={() => inspectUser(transfer.ID)}
                  backgroundcolor={theme.colors.grayTransparent}
                >
                  <HiOutlineEye size={25} />
                </Styled.IconV2Container>
              </Tooltip>
            </Box>
          ),
          align: 'center',
          width: '120px',
        },
      ],
    };
  });



  return (
    <Wrapper title="Transferências TED">
      <div>
        <Filter>
          <form onSubmit={handleSubmit(filterTable)}>
            <FirstFilterLine>
              <TextField label="Nome ou CPF/CNPJ" name={'SEARCH'} width={'24.042vw'} control={control} />
              <SelectOptions
                label={'Status'}
                width={'9.528vw'}
                name={'STATUS'}
                control={control}
                options={arrayStatus}
                initialValue={'0'}
              />
              <SelectOptions
                label={'Tipo'}
                width={'9.528vw'}
                name={'TIPO_TRANSACAO'}
                control={control}
                options={arrayTipoTransacao}
                initialValue={'0'}
              />
              <DateInput
                label="Data Inicial"
                name={'DATA_INICIAL'}
                width={'9.528vw'}
                control={control}
                value={dateInicial}
                onChange={(newValue) =>
                  newValue?.$d ? setDateInicial(moment(newValue?.$d).format('YYYY-MM-DD')) : setDateInicial(null)
                }
              />
              <DateInput
                label="Data Final"
                name={'DATA_FINAL'}
                width={'9.528vw'}
                control={control}
                value={dateFinal}
                onChange={(newValue) =>
                  newValue?.$d ? setDateFinal(moment(newValue?.$d).format('YYYY-MM-DD')) : setDateFinal(null)
                }
              />

              <Button
                backgroundcolor={theme.colors.buttonSearch}
                width="17.153vw"
                margin={'0 1.389vw 0 0'}
                hoverbgcolor={theme.colors.buttonSearchHover}
                hovercolor={theme.colors.buttonSearchHoverText}
                mycolor={theme.colors.buttonSearchText}
                type="submit"
              >
                <ImSearch className="default-svg" size={'1.181vw'} />
                <span>Buscar</span>
              </Button>
            </FirstFilterLine>
            <SecondFilterLine>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                <Box>
                  <Checkbox
                    onChange={(event) => handleChangeSelectAll(event)}
                    checked={verifyIfAllTransactionsAreSelected()}
                    indeterminate={
                      transfersData?.some(
                        (transfer) =>
                          transfer.STATUS_DESCRICAO === 'AGUARDANDO' && transactionSelected.includes(transfer.ID),
                      ) &&
                      !transfersData?.every(
                        (transfer) =>
                          transfer.STATUS_DESCRICAO !== 'AGUARDANDO' || transactionSelected.includes(transfer.ID),
                      )
                    }
                  />
                  <span>Selecionar todos</span>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  {transactionSelected.length > 0 && (
                    <Button onClick={() => aproveTransactionBatch()}>Aprovar transferências</Button>
                  )}

                  <h5>Resultados por página</h5>
                  <SelectOptions control={control} options={pagesOptions} name={'LIMIT'} initialValue={10} />
                  <h5>Total de resultados: {paginationTransfers?.totalResult}</h5>
                </Box>
              </Box>
            </SecondFilterLine>
          </form>
        </Filter>

        {loadingTransfers ? (
          <Loading />
        ) : (
          <Table
            loading={loadingTransfers}
            error={errorTransfers}
            hasPagination={true}
            filter={filter}
            pagination={paginationTransfers}
            setFilter={setFilter}
            errorMessage={messageTransfers}
            filterTable={filterTable}
            header={header}
            body={body}
            limit={filter.LIMIT}
          />
        )}

        {isModalInfoOpen && (
          <Modal
            open={isModalInfoOpen}
            close={() => setIsModalInfoOpen(false)}
            title="Dados da Transferência"
            width={'45.889vw'}
          >
            <InformationTransfer data={ModalInfoData} close={() => setIsModalInfoOpen(false)} />
          </Modal>
        )}

        {showModalTwoFactor && (
          <ModalTwoFactor
            open={showModalTwoFactor}
            onClose={handleCloseAndResetTransactionSelected}
            handleToken={aproveTransaction}
            onSubmit={(token) => aproveTransaction(token)}
            control={tokenControl}
          />
        )}
      </div>
    </Wrapper>
  );
}

export default memo(TransferenciaTed);
